// extracted by mini-css-extract-plugin
export default {"manager":"TagManager_manager__6vaqV","textTooltip":"TagManager_textTooltip__jKkV9","listOfTags":"TagManager_listOfTags__4EoJl"};